import styled from 'styled-components';

export const StyledBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
